import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["allocatedTotal", "remainingAmount"]
    static values = { remaining: Number, currency: String }

    connect() {
        this.amountInputs = this.element.querySelectorAll(".allocation-amount")

        this.amountInputs.forEach(input => {
            input.addEventListener("input", () => this.recalculate())
            input.addEventListener("focus", (e) => this.autoFillRow(e))
        })

        // ✅ Auto allocate once on load
        this.initialAutoAllocate()

        this.recalculate()
    }

    // -----------------------------
    // Initial auto distribution
    // -----------------------------
    initialAutoAllocate() {
        let remaining = this.remainingValue

        this.amountInputs.forEach(input => {
            if (remaining <= 0) return

            const amountDue = parseFloat(input.dataset.amountDue) || 0
            const assign = Math.min(amountDue, remaining)

            input.value = assign > 0 ? assign.toFixed(2) : ""
            remaining -= assign
        })
    }

    // -----------------------------
    // Auto fill when focusing empty input
    // -----------------------------
    autoFillRow(event) {
        const input = event.target
        const current = parseFloat(input.value) || 0

        if (current > 0) return

        const remaining = this.calculateRemaining()
        if (remaining <= 0) return

        const amountDue = parseFloat(input.dataset.amountDue) || 0
        const assign = Math.min(amountDue, remaining)

        input.value = assign.toFixed(2)
        this.recalculate()
    }

    // -----------------------------
    // Recalculate totals
    // -----------------------------
    recalculate() {
        let totalAllocated = 0

        this.amountInputs.forEach(input => {
            const value = parseFloat(input.value) || 0
            totalAllocated += value
        })

        const remaining = this.remainingValue - totalAllocated

        this.allocatedTotalTarget.innerText = this.format(totalAllocated)
        this.remainingAmountTarget.innerText = this.format(remaining)

        const isOverAllocated = remaining < 0

        // Show red color
        this.remainingAmountTarget.classList.toggle("fg-danger", isOverAllocated)

        // 🔥 Dispatch event to dialog
        this.element.dispatchEvent(
            new CustomEvent("form:state", {
                bubbles: true,
                detail: { valid: !isOverAllocated }
            })
        )
    }

    calculateRemaining() {
        let totalAllocated = 0

        this.amountInputs.forEach(input => {
            const value = parseFloat(input.value) || 0
            totalAllocated += value
        })

        return this.remainingValue - totalAllocated
    }

    format(amount) {
        return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: this.currencyValue
        }).format(amount)
    }
}